// extracted by mini-css-extract-plugin
export default {"back":"BackButton_back__+qWtH","chevronIcon":"BackButton_chevronIcon__FDzIm"};